import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  businesstypes: null,
  businesstypeo: null,
  sortBu: [],
  currentPage: null
}

const mutations = {  
  SET_BUSINESSTYPES (state, payload) {
    state.businesstypes = payload
  },
  SET_BUSINESSTYPE (state, payload) {
    state.businesstypeo = payload
  },
  SET_SORT_BU (state, payload) {
    state.sortBu = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  businessTypeList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }
    
    return Vue.http.post(`${env.API}/api/business-type/list`, data)    
      .then((response) => {        
        context.commit('SET_BUSINESSTYPES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  businessSelectList: (context, data) => {
    return Vue.http.get(`${env.API}/api/business-type/select-list`)    
      .then((response) => {        
        context.commit('SET_PRODUCTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  businessTypeByIds: (context, data) => {
    let query = '?'
    if (Array.isArray(data)) {
      for (let element of data) {                 
        query += `&ids[]=${element}`
      }
    }
    return Vue.http.get(`${env.API}/api/business-type/by-ids${query}`)    
      .then((response) => {        
        context.commit('SET_BUSINESSTYPES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  businessTypeById: (context, id) => {
    return Vue.http.get(`${env.API}/api/business-type/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_BUSINESSTYPE', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updatebusinessType: (context, data) => {
    return Vue.http.put(`${env.API}/api/business-type/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createBusinessType: (context, data) => {
    return Vue.http.post(`${env.API}/api/business-type`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  }
  ,
  deleteBusinessType: (context, data) => {
    return Vue.http.delete(`${env.API}/api/business-type/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  updateSortBu: (context, data) => {
    return context.commit('SET_SORT_BU', data)
  },
  businessBySegTraProd: (context, data) => {
    return Vue.http.post(`${env.API}/api/business-type/by-seg-trav-prod`, data)    
      .then((response) => {
        context.commit('SET_BUSINESSTYPES', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  }
}

const getters = {
  getBusinessType: (state) => state.businesstypes,
  getBT: (state) => state.businesstypeo,
  getSortBu: (state) => state.sortBu,
  getCurrentPage: (state) => state.currentPage
}

export const businesstype = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/businesstype.js